import { useQuery } from "@tanstack/react-query"
import { getBackofficeScheduledReportQuery } from "modules/backoffice/lib/scheduledReports/getBackofficeScheduledReportQuery"

export function useGetBackofficeScheduledReportQuery(
  ...args: Parameters<typeof getBackofficeScheduledReportQuery>
) {
  return useQuery(getBackofficeScheduledReportQuery(...args))
}
